<template>
  <div>
    <el-dialog
      :title="isCreate ? '新增白名单' : '编辑白名单'"
      center
      :visible="true"
      @close="close"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="600px"
    >
      <el-form ref="form" label-width="150px" size="mini">
        <el-form-item label="AID：" prop="aid">
          <el-input v-model="form.aid" style="width: 140px"></el-input>
        </el-form-item>
        <el-form-item label="备注：" prop="remark">
          <el-input
            type="textarea"
            rows="5"
            v-model="form.remark"
            clearable
            style="width: 350px"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="close">取消</el-button>
        <el-button
          type="primary"
          @click="operation(isCreate ? 'add' : 'edit', form)"
          >保存</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
const axios = require("axios");
const util = require("@/util");
import bizutil from "@/bizutil";
const dialogutil = require("@/dialogutil");

// 本弹窗名称
const DialogName = "EditWhiteListEntryOfGmDialog";

export default {
  data() {
    return {
      isCreate: true,
      form: {
        aid: "",
        remark: "",
      },
    };
  },
  components: {},
  async created() {
    let value = dialogutil.getData(DialogName);

    this.isCreate = value.isCreate;
    if (!this.isCreate) {
      this.form = value.entry;
    }
  },

  methods: {
    async operation(op, entry) {
      try {
        switch (op) {
          case "add": {
            // 弹确认框
            await this.$confirm(`确认新增白名单项：${entry.aid}？`);
            break;
          }
          case "edit": {
            // 弹确认框
            await this.$confirm(`确认更新白名单：${entry.aid}？`);
            break;
          }
          default: {
            this.$message.error("未知操作：" + op);
            return;
          }
        }

        let resData = (
          await axios.post(
            `${util.getBackendApiBase()}/v1/admin/whiteListEntry/operationWhiteListEntryForGm`,
            {
              operation: op,
              entry: entry,
            },
            {
              headers: {
                token: bizutil.getLoginUserToken(),
              },
            }
          )
        ).data;
        if (resData.code > 0) {
          this.$message.error(resData.message);
          return;
        }

        this.$message({
          message: "操作成功",
          type: "success",
        });

        this.close();
      } catch (e) {}
    },
    close() {
      // 关闭当前对话框
      dialogutil.close(DialogName);
    },
  },
};
</script>